module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "position": "absolute",
      "line-height": "46px"
    }
  }, [_vm._v("Tổng số "), _c('span', {
    staticClass: "text-bold primary--text"
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" thủ tục. ")]), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "vue-tiny-pagination pagination layout"
  }, [_c('div', {
    staticClass: "pr-3 xs4 flex"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.totalPagesData,
      "item-text": "text",
      "item-value": "value",
      "autocomplete": ""
    },
    on: {
      "input": _vm.goToPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "tiny-pagination",
    class: _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classFirstPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPageLast($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("first_page")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classFirstPage,
    staticStyle: {
      "border-left": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("chevron_left")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation pagination__navigation--disabled text-bold primary--text",
    staticStyle: {
      "border-right": "0",
      "border-left": "0"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.titlePage) + "\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classLastPage,
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classLastPage,
    staticStyle: {
      "border-left": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("chevron_right")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classLastPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classLastPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPageLast($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("last_page")])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7907e2b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7907e2b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination1.vue
// module id = 533
// module chunks = 1